import * as React from 'react';
import { useTheme } from '../../../../../../theme';
import { CardExtraSummaryNotification } from '../CardExtraSummaryNotification';
const VISIBLE_NOTIFICATION_STATUSES = ['requested', 'unconfirmed'];
const CardExtraSummaryGroup = ({ icon, status, segmentLabel, travellerLabel, children }) => {
    const { CardExtraSummaryGroup: theme } = useTheme('Shared').CardExtraView;
    return (React.createElement("div", { className: theme.root },
        (icon || travellerLabel || segmentLabel) && (React.createElement("div", { className: theme.header },
            (icon || travellerLabel) && (React.createElement("div", { className: theme.label },
                icon,
                React.createElement("span", null, travellerLabel))),
            segmentLabel && React.createElement("span", { className: theme.label }, segmentLabel))),
        children,
        VISIBLE_NOTIFICATION_STATUSES.includes(status) && React.createElement(CardExtraSummaryNotification, { status: status })));
};
export default CardExtraSummaryGroup;
